import { useEffect, useMemo } from 'react';
import { useStore } from '../../../stores/store';
import usePrevious from '../../../hooks/use-previous.hook';

const useShipmentType = () => {
  const {
    parcelCreationStore: {
      countryDeparture,
      getDeliveryLimitations,
      setShipmentType,
      shipmentType,
      prefillInProgress,
    },
    shipmentCountriesStore: { allowedShipmentTypes, getAllowedShipmentTypes },
  } = useStore();

  const prevShipmentType = usePrevious(shipmentType);

  const shipmentTypes = useMemo(
    () => getAllowedShipmentTypes(countryDeparture?.code),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allowedShipmentTypes, countryDeparture?.code, getAllowedShipmentTypes]
  );

  const showShipmentTypeRadioBlock = shipmentTypes.length > 1;

  useEffect(() => {
    if (shipmentType || shipmentTypes.length === 0) return;

    setShipmentType(shipmentTypes[0]);
  }, [shipmentType, shipmentTypes, setShipmentType]);

  useEffect(() => {
    if (
      prefillInProgress ||
      !prevShipmentType ||
      prevShipmentType === shipmentType
    )
      return;

    getDeliveryLimitations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shipmentType, getDeliveryLimitations, prefillInProgress]);

  return {
    showShipmentTypeRadioBlock,
    shipmentTypes,
  };
};

export default useShipmentType;
